import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.5 2.053c-.3-.195-.7-.097-1 .098L17 5.964v-3.03C17 1.271 15.7 0 14 0H3C1.3 0 0 1.271 0 2.933v9.776c0 1.662 1.3 2.933 3 2.933h11c1.7 0 3-1.271 3-2.933v-3.03l5.4 3.812c.2.098.4.196.6.196s.3 0 .5-.098c.3-.196.5-.489.5-.88V2.933c0-.39-.2-.684-.5-.88M15 12.709c0 .587-.4.978-1 .978H3c-.6 0-1-.391-1-.978V2.933c0-.586.4-.977 1-.977h11c.6 0 1 .39 1 .977zm7-1.857-4.3-3.03L22 4.791z"
    }, null, -1)
  ]))]))
}
export default { render: render }